export const fourEyesPrincipleUserIdValidator = (t, currentUserId) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('four-eyes-principle.validation.user-id-empty');
    } else if (input.trim() === currentUserId) {
        err = t('four-eyes-principle.validation.same-user-id');
    }
    return err;
};

export const fourEyesPrinciplePasswordValidator = (t) => (input) => {
    let err = null;
    if (input.trim().length === 0) {
        err = t('four-eyes-principle.validation.password-empty');
    }
    return err;
};
